import type { FC } from 'react';
import type { ProjectData, CaseStudyProps } from '../data-projects';

export const CapmoAI: FC<ProjectData & CaseStudyProps> = ({ cta }) => {
  return (
    <>
      <section>
        <h3>Inefficient data management costs construction firms €500K+ annually</h3>
        <h4>The Push for Change</h4>
        <p>
          Capmo, a European construction management platform with €30M+ in funding, identified significant productivity losses among their enterprise clients. Project managers were spending excessive time searching for information across disconnected systems, reducing time available for strategic project oversight.
        </p>
        <p>
          Construction companies with 100+ employees typically lose over €500,000 annually due to inefficient information retrieval processes. Capmo needed an AI solution to consolidate project data and reduce search times.
        </p>
      </section>

      <section id="solution">
        <h3>AI knowledge system reduces search time by 75%</h3>
        <h4>Shaping Solutions from Technology</h4>
        <p>
          Capmo AI functions as an intelligent assistant that provides instant access to project information from multiple data sources. The system uses natural language processing to deliver relevant answers with source citations, eliminating manual document searches.
        </p>
        <p>
          Implementation required enterprise-grade data governance, user access controls, and integration with existing construction management workflows. The solution needed to handle diverse document types while maintaining response accuracy.
        </p>
      </section>

      <section id="results">
        <h3>38% reduction in administrative workload drives ROI</h3>
        <h4>Delivering Lasting Results</h4>
        <p>
          Capmo AI delivered measurable productivity improvements: 4x faster information retrieval, 38% reduction in manual administrative tasks, and 50% improvement in defect management response times. These efficiency gains translate directly to project cost savings.
        </p>
        <p>
          The most significant impact was reducing document search time from an average of 10 minutes to 2 seconds, allowing project managers to focus on value-adding activities rather than information gathering.
        </p>
      </section>

      {cta}
    </>
  );
};



